<template>
  <div class='title-div'>
    <wc-page-title title='Day View' :subtitle='subtitle' fullWidth></wc-page-title>
    <shift-buttons
      title='Today'
      weekButton
      monthButton
      :date='date'
      :disableToday='disableToday'
      :showWOs='showWOs'
      :loading='isLoading'
      @clearScheduleData='clearScheduleData'
      @deselect="deselect"
      @prev='goToPrevDay'
      @today='goToToday'
      @next='goToNextDay'
      @toggleShowWOs='showWOs = !showWOs'
      @archiveWOs="$emit('archiveWOs')"
    ></shift-buttons>
    <v-divider class='ml-3 mb-3'></v-divider>
    <div :class='this.$store.state.nav.showDrawer ? "schedule-container" : "schedule-container-expanded scrollable"'>

<!-- sort routes by id here so that they don't change positions after creation -->
<!-- this view will be responsible for displaying routes in horizontal fashion -->
<!-- THIS NEEDS CLEANUP -->

      <div class='mt-2'>
        <!-- <wc-loading v-if='isLoading' line msg='Loading items...'></wc-loading> -->
        <table height='100%'>
          <tr>
            <td v-for='route in orderedRoutes' valign='top' :key='route.id' class='schedule-items-box pr-5'>
              <route
                :route='route'
                :isLoading='isLoading'
                :showWOs='showWOs'
                :showInsertBox='showInsertBox'
                @getFullRoute='getFullRoute'
                @select='select'
                @deselect='deselect'
                @openCrewVisits='openCrewVisits'
                @deleteRoute='deleteRoute'
                @openQuickView='openQuickView'
                @updateRoute='updateRoute'
                @moveWOs='moveWOs'
                @updateWO='updateWO'
              ></route>
            </td>
            <td class='text-center schedule-items-box' valign='top'>
              <add-route-button
                :date='date'
                :schedule='schedule'
                @addRoute='addRoute'>
              </add-route-button>
            </td>
            <td v-if='routes.length === 0 && isLoading === false'>
              <h3 class='grey--text ml-5 mt-n1'>
                No routes this day
              </h3>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import ShiftButtons from '../../components/ShiftButtons';
import Route from './Route';
import AddRouteButton from './AddRouteButton';
import _ from 'lodash';

export default {
  name: 'day-view',
  props: {
    schedule: {
      required: true
    },
    isLoading: {
      required: true
    },
    routes: {
      required: true
    }
  },
  data: () => ({
    showWOs: true
  }),
  computed: {
    showInsertBox () {
      return this.$store.state.schedule.selectedWOs.length > 0
    },
    date () {
      return moment(this.$route.params.date).format('YYYY-MM-DD').toString()
    },
    today () {
      return moment().format('YYYY-MM-DD').toString()
    },
    nextDay () {
      return moment(this.$route.params.date).add(1, 'days').format('YYYY-MM-DD').toString()
    },
    prevDay () {
      return moment(this.$route.params.date).subtract(1, 'days').format('YYYY-MM-DD').toString()
    },
    subtitle () {
      return this.$options.filters.longDateWithDay(this.date)
    },
    disableToday () {
      return moment(this.date).isSame(this.today, 'day')
    },
    orderedRoutes () {
      return _.orderBy(this.routes, 'id')
    }
  },
  mounted () { 
    console.log('day view mounted')
    this.$emit('dateChange', this.date, this.date)
  },
  methods: {
    goToToday () {
      this.$emit('dateChange', this.today, this.today)
      this.$router.push({ name: 'ScheduleDay', params: { id: this.$route.params.id, date: this.today } })
    },
    goToNextDay () {
      this.$emit('dateChange', this.nextDay, this.nextDay)
      this.$router.push({ name: 'ScheduleDay', params: { id: this.$route.params.id, date: this.nextDay } })
    },
    goToPrevDay () {
      this.$emit('dateChange', this.prevDay, this.prevDay)
      this.$router.push({ name: 'ScheduleDay', params: { id: this.$route.params.id, date: this.prevDay } })
    },
    addRoute (obj) {
      console.log('add route in day view', obj)
      this.$emit('addRoute', obj)
    },
    updateRoute (route) {
      this.$emit('updateRoute', route)
    },
    openQuickView (wo) {
      this.$emit('openQuickView', wo)
    },
    deleteRoute (route) {
      this.$emit('deleteRoute', route)
    },
    openCrewVisits (wo) {
      this.$emit('openCrewVisits', wo)
    },
    updateWO (wo) {
      this.$emit('updateWO', wo)
    },
    select (woArray) {
      this.$emit('select', woArray)
    },
    deselect (woArray) {
      this.$emit('deselect', woArray)
    },
    getFullRoute (routeID) {
      this.$emit('getFullRoute', routeID)
    },
    moveWOs (routeID, beforeWoID = 0) {
      this.$emit('moveWOs', routeID, beforeWoID)
    },
    clearScheduleData () {
      this.$emit('clearScheduleData')
    },
  },
  components: {
    'add-route-button': AddRouteButton,
    'shift-buttons': ShiftButtons,
    'route': Route
  }
}
</script>

<style>
.scrollable {
  overflow-x: scroll;
}
</style>
